import styled from 'styled-components';
import { config } from '../../constants/config';

const WatermarkContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const WatermarkText = styled.div<{ $environment: string }>`
  position: absolute;
  font-size: 8rem;
  color: rgba(84, 84, 84, 0.08);
  transform: rotate(45deg);
  transform-origin: center center;
  user-select: none;
  text-transform: uppercase;
  letter-spacing: 0.5em;
  white-space: nowrap;
  
  @media (max-width: 768px) {
    font-size: 4rem;
  }
  
  @media (max-width: 480px) {
    font-size: 2.5rem;
  }
`;

export function EnvironmentWatermark() {
  // Only show watermark in non-production environments
  if (config.environment === 'production') {
    return null;
  }

  const watermarkText = config.environment === 'development' ? 'TEST' : 
                        config.environment === 'staging' ? 'STAGING' : 
                        'DEV';

  return (
    <WatermarkContainer>
      <WatermarkText $environment={config.environment}>
        {watermarkText}
      </WatermarkText>
    </WatermarkContainer>
  );
}